import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { api_url } from "../config/config";
import { FaEye } from "react-icons/fa";
const OrderList = () => {
  const [showOrderStatusHistoryModal, setShowOrderStatusHistoryModal] =
    useState(false);
  const [orderStatusHistory, setOrderStatusHistory] = useState([]);
  const [orderStatusHistoryOrder, setOrderStatusHistoryOrder] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [erp_order_id, setErpOrderId] = useState("");
  const [cancellationReason, setCancellationReason] = useState("");
  const [viewOrder, setViewOrder] = useState(null);
  const [branches, setBranches] = useState([]);
  const tableRef = useRef(null);
  const [orders, setOrders] = useState([]);
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [transferOrderId, setTransferOrderId] = useState(null);
  const [branchData, setBranchData] = useState(true);
  const token = localStorage.getItem("admin_token");
  const role = localStorage.getItem("roles");
  const [comments, setComments] = useState("");

  const [filters, setFilters] = useState({
    date: "",
    searchTerm: "",
    status: "",
    city: "",
    branch: "",
  });
  const statusOptions = [
    "ORDER_PLACED",
    "ORDER_PROCESSING",
    "OUT_FOR_DELIVERY",
    "DELIVERED",

    "CANCELLED",
  ];
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [newStatus, setNewStatus] = useState("");
  const [debouncedFilters, setDebouncedFilters] = useState(filters);
  const [trigger, setTrigger] = useState(false);
  const [userOrders, setUserOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const fetchUserOrders = async () => {
    const token = localStorage.getItem("admin_token");
    if (!token) {
      console.error("Token not found! User might not be authenticated.");
      return;
    }

    setLoading(true); // Start loading

    try {
      let result = await axios.get(`${api_url}/orders`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      setUserOrders(result.data?.data || []);
    } catch (error) {
      console.error(
        "Error fetching user orders:",
        error.response ? error.response.data : error.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserOrders();
  }, []);

  const openModal = (review, rating) => {
    setSelectedReview({ review, rating });
    setShowModal(true);
  };
  // Update order status locally
  const updateOrderStatus = (id, status) => {
    const updatedOrders = orders.map((order) =>
      order.id === id ? { ...order, status } : order,
    );
    setOrders(updatedOrders);
    setSelectedOrder(null);
  };

  useEffect(() => {
    if (showTransferModal) {
      const fetchBranches = async () => {
        try {
          const response = await axios.get(`${api_url}/branches`);

          const rawBranches = response.data.results || [];

          const uniqueBranches = [
            ...new Map(
              rawBranches.map((branch) => [branch.branch_id, branch]),
            ).values(),
          ];

          setBranchData(uniqueBranches);
          console.log("Unique Branches:", uniqueBranches);
        } catch (error) {
          console.error("Error fetching branches:", error);
        }
      };

      fetchBranches();
    }
  }, [showTransferModal]);

  const handleTransfer = async () => {
    try {
      await axios.patch(
        `${api_url}/transfer-order/${transferOrderId.orderId}`,
        {
          branch_id: selectedBranch,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      alert("Order transferred successfully!");
      setShowTransferModal(false);
    } catch (err) {
      console.error("Transfer failed", err);
      alert("Transfer failed");
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toISOString().split("T")[0];
  };

  // const filteredOrders = userOrders.filter((order) => {

  //   const matchesDate = filters.date
  //     ? formatDate(order.created_at) === filters.date
  //     : true;

  //   const term = searchTerm.trim().toLowerCase();
  //   const matchesSearch = term
  //     ? (
  //         (order.order?.user?.name?.toLowerCase() || "").includes(term) ||
  //         (order.orderId?.toLowerCase() || "").includes(term) ||
  //         (order.order?.user?.mobile_number?.toLowerCase() || "").includes(term)
  //       )
  //     : true;
  //   return matchesDate && matchesSearch;
  // });

  // Fetch Orders with filters
  const fetchOrder = async () => {
    const { date, amount, city, searchTerm, status } = debouncedFilters;

    console.log("filter branch", filters.branch);

    try {
      const { data } = await axios.get(
        `${api_url}/orders?page=1&limit=100&date=${date}&city=${city}&search=${searchTerm}&status=${status}&branch=${filters.branch}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
          },
        },
      );
      setUserOrders(data.data || []);
      console.log(data.data);
    } catch (e) {
      console.error("Error fetching orders", e);
    }
  };

  // Update order status API call
  const fetchUpdateStatus = async (order_id, newStatus, erp_order_id) => {
    try {
      if (!newStatus) {
        alert("Please select a status.");
        return;
      } else if (newStatus === "CANCELLED" && !cancellationReason) {
        alert("Please provide a cancellation reason.");
        return;
      }

      const { data } = await axios.patch(
        `${api_url}/admin-order/${order_id}`,
        {
          delivery_status: newStatus,
          erp_order_id,
          reason: cancellationReason,
          comments,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
          },
        },
      );

      setOrders(data.data);
      setTrigger(!trigger);
      setSelectedOrder(null);
      alert("Update Success");
      fetchUserOrders();
    } catch (e) {
      console.error(
        "Error occurred during status update:",
        e.response ? e.response.data : e.message,
      );
      alert("An error occurred while updating the status.");
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedFilters(filters);
    }, 500);

    return () => clearTimeout(timer);
  }, [filters]);

  useEffect(() => {
    fetchOrder();
  }, [debouncedFilters, trigger]);

  // Reset Filters
  const resetFilters = () => {
    setFilters({
      date: "",
      city: "",
      searchTerm: "",
      status: "",
      branch: "",
    });
    setSearchTerm("");
  };

  const cancellationReasonsForMapping = [
    "Out of stock",
    "Pricing/Listing error",
    "Other",
  ];

  const fetchBranches = async () => {
    try {
      const response = await axios.get(
        `${api_url}/branches?search=${searchTerm}`,
      );

      const rawBranches = response.data.results || [];

      const uniqueBranches = [
        ...new Map(
          rawBranches.map((branch) => [branch.branch_id, branch]),
        ).values(),
      ];

      setBranches(uniqueBranches);
      console.log("Unique Branches:", uniqueBranches);
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  function ReviewCell({ review, rating }) {
    const [expanded, setExpanded] = useState(false);

    return (
      <div>
        <p
          className={`font-medium text-gray-800 ${
            expanded ? "" : "line-clamp-2"
          }`}
        >
          {review}
        </p>

        <button
          className="text-blue-500 text-xs mt-1"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "Show Less" : "Read More"}
        </button>

        <p className="text-yellow-500">⭐ {rating}/5</p>
      </div>
    );
  }

  return (
    <div className="p-4 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-4">Orders List</h1>

      <div className="flex gap-4 mb-6">
        <input
          type="text"
          className="border rounded-xl border-slate-700 p-2 w-[300px] px-3"
          placeholder="Search by username, order ID,mobile number"
          title="Search by username, order ID, mobile number"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setFilters({ ...filters, searchTerm: e.target.value });
          }}
        />

        <input
          type="date"
          className="p-2 border border-gray-300 rounded"
          placeholder="Filter by date"
          value={filters.date}
          onChange={(e) => setFilters({ ...filters, date: e.target.value })}
          max={new Date().toISOString().split("T")[0]}
        />
        <select
          className="p-2 border border-gray-300 rounded"
          value={filters.status}
          onChange={(e) => {
            setFilters({ ...filters, status: e.target.value });
          }}
        >
          <option value="">Select Status</option>
          {[
            "ORDER_PLACED",
            "ORDER_RECEIVED",
            "ORDER_PROCESSING",
            "OUT_FOR_DELIVERY",
            "DELIVERED",

            "CANCELLED",
          ].map((status) => (
            <option key={status} value={status}>
              {status.replace(/_/g, " ")}
            </option>
          ))}
        </select>
        <select
          className="p-2 border border-gray-300 rounded max-w-[200px]"
          value={filters.branch}
          onChange={(e) => {
            setFilters({ ...filters, branch: e.target.value });
          }}
        >
          <option value="">Select Branch</option>
          {branches.map((branch) => (
            <option key={branch.branch_id} value={branch.branch_id}>
              {branch.area}
            </option>
          ))}
        </select>
        {/* Reset Button */}
        <button
          className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
          onClick={resetFilters}
        >
          Reset Filters
        </button>
        <div
          className="bg-green-500 flex items-center px-5 rounded-lg
                 hover:text-white cursor-pointer hover:bg-green-400 transition-all duration-400 hover:scale-x-105"
        >
          <DownloadTableExcel
            filename="Orders_List"
            sheet="orders"
            currentTableRef={tableRef.current}
          >
            <button> Export excel </button>
          </DownloadTableExcel>
        </div>
      </div>

      {/* Orders Table */}
      <div className="overflow-x-auto text-xs bg-white h-[700px] overflow-y-scroll py-2 px-2 rounded-xl">
        <table
          className="table-auto w-full border-collapse border border-gray-200"
          ref={tableRef}
        >
          <thead>
            <tr className="bg-gray-200 rounded-tr-lg">
              <th className="p-2 first:rounded-tl-lg">Order ID</th>
              <th className="p-2 first:rounded-tl-lg">Razorpay Order ID</th>
              <th className="p-2 border">ERP Order ID</th>
              <th className="p-2 border">Username</th>
              {/* <th className="p-4 border">Email</th> */}
              <th className="p-2 border">Billing / Pick up Address</th>
              {/* <th className="p-4 border">Shipping Address</th> */}
              <th className="p-2 border">Phone No</th>
              <th className="p-2 border last:rounded-tr-xl">Feedbacks</th>
              <th className="p-2 border ">Product Details</th>
              <th className="p-2 border">Invoice</th>
              <th className="p-2 border">Status</th>
              <th className="p-2 border last:rounded-tr-xl">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan="7"
                  className="p-4 text-center text-gray-500 animate-pulse"
                >
                  Loading orders...
                </td>
              </tr>
            ) : userOrders.length > 0 ? (
              userOrders.map((order) => (
                <tr key={order.id} className="odd:bg-white even:bg-gray-50">
                  <td className="p-4 border text-left text-sm">
                    {order.sequence_id}
                  </td>
                  <td className="p-2 border text-left text-sm">
                    {order.orderId}
                  </td>
                  <td className="p-4 border text-left text-sm">
                    {order.ERP_Order_id || "N/A"}
                  </td>
                  <td className="p-4 border text-left text-sm">
                    {order.order.user.name}
                  </td>
                  <td className="p-4 border text-left text-sm">
                    {order.shipping_address ? (
                      <>
                        <span className="block font-semibold">
                          {order.shipping_address.deliver_to}
                        </span>
                        <span>
                          {order.shipping_address.city},{" "}
                          {order.shipping_address.state}
                        </span>
                        <br />
                        <span className="text-sm text-gray-500">
                          {" "}
                          {order.shipping_address.pincode}
                        </span>
                      </>
                    ) : order.branch ? (
                      <>
                        <span className="block font-semibold">
                          {" "}
                          {order.branch.area}
                        </span>
                        <span>{order.branch.branch_address}</span>
                        {role !== "EMPLOYEE" && (
                          <button
                            onClick={() => {
                              setShowTransferModal(true);
                              setTransferOrderId(order);
                            }}
                            className="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-xs font-medium rounded-md shadow-sm transition duration-200 ease-in-out"
                          >
                            Transfer
                          </button>
                        )}
                      </>
                    ) : (
                      <span className="text-sm text-gray-500">
                        No Address Available
                      </span>
                    )}
                  </td>
                  <td className="p-2 border text-sm">
                    {order.order.user.mobile_number || "N/A"}
                  </td>
                  <td className="p-2 border text-sm">
                    {order.OrderReview?.length > 0 ? (
                      <button
                        className="text-blue-600 underline text-sm"
                        onClick={() =>
                          openModal(
                            order.OrderReview[0].review,
                            order.OrderReview[0].rating,
                          )
                        }
                      >
                        View Review
                      </button>
                    ) : (
                      "N/A"
                    )}
                  </td>

                  <td className="p-4 border">
                    <button
                      className="text-blue-500 underline"
                      onClick={() => {
                        setViewOrder(order);
                        setShowViewModal(true);
                      }}
                    >
                      View
                    </button>
                  </td>
                  <td className="p-4 border text-sm">
                    {order.invoice ? (
                      <a
                        href={order.invoice}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:underline"
                      >
                        View Invoice
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </td>

                  <td className="p-4 border">
                    <span
                      className={`px-2 py-1 text-sm font-semibold rounded-full cursor-pointer hover:underline
                      ${
                        order.delivery_status === "ORDER_PLACED"
                          ? "bg-yellow-300 text-black"
                          : [
                                "ORDER_PROCESSING",
                                "ORDER_RECEIVED",
                                "DELIVERED",
                                "OUT_FOR_DELIVERY",
                              ].includes(order.delivery_status)
                            ? "bg-[#228200] text-white"
                            : order.delivery_status === "CANCELLED"
                              ? "bg-red-500 text-white"
                              : "bg-gray-300 text-gray-800"
                      }`}
                      onClick={() => {
                        setOrderStatusHistory(
                          order.OrderDeliveryStatusHistory || [],
                        );
                        setShowOrderStatusHistoryModal(true);
                        setOrderStatusHistoryOrder(order);
                      }}
                    >
                      {order.delivery_status}
                    </span>
                  </td>

                  <td className="p-4 border">
                    <div className="flex flex-col gap-2">
                      <button
                        className="px-6 py-2 bg-[#5FBDB3] items-center text-white text-[12px] rounded-md hover:bg-[#3d7b74] focus:ring-2 focus:ring-[#5FBDB3] focus:ring-offset-2 disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed disabled:hover:bg-gray-300 disabled:focus:ring-0"
                        onClick={() => setSelectedOrder(order)}
                        disabled={order.delivery_status === "CANCELLED"}
                      >
                        Update Order Status
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="p-4 text-center text-gray-500">
                  No orders found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Modal for Updating Status */}
      {selectedOrder && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-xl w-96">
            <h2 className="text-lg font-bold text-gray-800 mb-4">
              Update Status for Order #{selectedOrder.order_id}
            </h2>
            <select
              className="w-full p-2 border border-gray-300 rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-[#5FBDB3]"
              value={newStatus}
              onChange={(e) => setNewStatus(e.target.value)}
            >
              <option value="" disabled>
                Select Status
              </option>
              {[
                "ORDER_RECEIVED",
                "ORDER_PROCESSING",
                "OUT_FOR_DELIVERY",
                "DELIVERED",

                "CANCELLED",
              ].map((status) => (
                <option key={status} value={status}>
                  {status.replace(/_/g, " ")}
                </option>
              ))}
            </select>
            {newStatus === "CANCELLED" && (
              <>
                <label className="font-bold text-gray-800">
                  Cancellation Reason*
                </label>
                <select
                  className="w-full p-2 border border-gray-300 rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-[#5FBDB3]"
                  value={cancellationReason}
                  onChange={(e) => setCancellationReason(e.target.value)}
                >
                  <option value="">Select Cancellation Reason</option>
                  {cancellationReasonsForMapping.map((reason, idx) => (
                    <option key={idx} value={reason}>
                      {reason}
                    </option>
                  ))}
                </select>
              </>
            )}
            <label className="font-bold text-gray-800">ERP Order ID</label>
            <input
              type="text"
              placeholder="Enter ERP Order ID"
              className="w-full p-2 border border-gray-300 rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-[#5FBDB3]"
              value={erp_order_id}
              onChange={(e) => setErpOrderId(e.target.value)}
            />
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Comments (optional)
            </label>
            <textarea
              type="text"
              className="w-full p-2 border border-gray-300 rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-[#5FBDB3]"
              placeholder="Add comments here..."
              value={comments}
              rows="3"
              onChange={(e) => setComments(e.target.value)}
            />
            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300"
                onClick={() => setSelectedOrder(null)}
              >
                Cancel
              </button>
              <button
                className={`px-4 py-2 text-white rounded-lg ${
                  newStatus
                    ? "bg-[#5FBDB3] hover:bg-[#3d7b74]"
                    : "bg-gray-400 cursor-not-allowed"
                }`}
                onClick={() => {
                  if (newStatus) {
                    fetchUpdateStatus(
                      selectedOrder.orderId,
                      newStatus,
                      erp_order_id,
                    );
                  } else {
                    alert("Please select a status before updating.");
                  }
                }}
                disabled={!newStatus}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      )}

      {showViewModal && viewOrder && (
        <div className="fixed inset-0 z-50 flex justify-end">
          <div
            className="fixed inset-0 bg-black bg-opacity-40"
            onClick={() => setShowViewModal(false)}
          ></div>
          <div className="relative w-full max-w-md bg-white h-full shadow-xl overflow-y-auto p-8 flex flex-col">
            <button
              className="absolute top-4 right-4 text-gray-600 hover:text-red-500 text-2xl font-bold"
              onClick={() => setShowViewModal(false)}
              aria-label="Close"
            >
              &times;
            </button>
            <h2 className="text-xl font-bold mb-6">Order Details</h2>
            <div className="mb-4">
              <span className="font-semibold">Order ID:</span>{" "}
              {viewOrder.sequence_id}
            </div>
            <div className="mb-4">
              <span className="font-semibold">Razorpay Order ID:</span>{" "}
              {viewOrder.orderId}
            </div>
            <div className="mb-4">
              <span className="font-semibold">Username:</span>{" "}
              {viewOrder.order?.user?.name}
            </div>
            <div className="mb-4">
              <span className="font-semibold">Product Details:</span>
              <table className="w-full mt-2 border text-xs">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="p-2 border">S.No</th>
                    <th className="p-2 border">Name</th>
                    <th className="p-2 border">Quantity</th>
                    <th className="p-2 border">Price</th>
                    <th className="p-2 border">Discounted Price</th>
                  </tr>
                </thead>
                <tbody>
                  {viewOrder.product?.map((prod, idx) => (
                    <tr key={idx}>
                      <td className="p-2 border text-center">{idx + 1}</td>
                      <td className="p-2 border">
                        {prod?.variant?.product?.name || "-"}
                      </td>
                      <td className="p-2 border text-center">
                        {prod.quantity}
                      </td>
                      <td className="p-2 border text-center">
                        ₹{prod.price?.toFixed(2)}
                      </td>
                      <td className="p-2 border text-center">
                        ₹{prod.variant.discounted_price?.toFixed(2)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="p-2 border text-center">
                Total Amount: ₹
                {viewOrder.bill?.[0]?.totalAmount?.toFixed(2) || "0.00"}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal for Order Delivery Status History */}
      {showOrderStatusHistoryModal && orderStatusHistoryOrder && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-3xl mx-4 relative">
            <div className="flex justify-between items-center border-b p-4">
              <h2 className="text-lg font-semibold">
                Order Delivery Status History
              </h2>
              <button
                className="text-2xl leading-none text-gray-500 hover:text-gray-700"
                onClick={() => setShowOrderStatusHistoryModal(false)}
                aria-label="Close"
              >
                &times;
              </button>
            </div>
            <div className="p-6">
              <p className="mb-2">
                <span className="font-bold">Order ID:</span>{" "}
                {orderStatusHistoryOrder.orderId ||
                  orderStatusHistoryOrder.sequence_id ||
                  orderStatusHistoryOrder.id}
              </p>
              <p className="mb-2">
                <span className="font-bold">Current Status:</span>{" "}
                {orderStatusHistoryOrder.delivery_status}
              </p>
              {orderStatusHistoryOrder.delivery_status === "CANCELLED" &&
                orderStatusHistoryOrder.cancellation_reason && (
                  <p className="mb-4">
                    <span className="font-bold">Cancellation Reason:</span>{" "}
                    {orderStatusHistoryOrder.cancellation_reason ||
                      "Cancelled During Payment"}
                  </p>
                )}
              {Array.isArray(orderStatusHistory) &&
              orderStatusHistory.length > 0 ? (
                <div className="overflow-x-auto max-h-96 overflow-y-auto">
                  <table className="table-auto w-full text-left border-collapse text-sm">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="p-2 border">Old Status</th>
                        <th className="p-2 border">New Status</th>
                        <th className="p-2 border">Updated By</th>
                        <th className="p-2 border">User Type</th>
                        <th className="p-2 border">Comments</th>
                        <th className="p-2 border">Updated Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {orderStatusHistory.map((h, idx) => {
                        const updatedBy =
                          h.UserType === "ADMIN_USER"
                            ? h.updatedByAdmin?.name || "Admin"
                            : h.updatedByUser?.name || "User";
                        return (
                          <tr key={idx}>
                            <td className="p-2 border capitalize">
                              {h.old_status}
                            </td>
                            <td className="p-2 border capitalize">
                              {h.new_status}
                            </td>
                            <td className="p-2 border">{updatedBy}</td>
                            <td className="p-2 border">{h.UserType}</td>
                            <td className="p-2 border">{h.comments || "-"}</td>
                            <td className="p-2 border">
                              {new Date(h.updated_at).toLocaleString()}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <span className="text-gray-500">No status history</span>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal */}
      {showModal && selectedReview && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
            <h3 className="font-bold text-lg mb-3">Review</h3>

            {/* Fix long text overflow */}
            <p className="text-gray-800 mb-4 break-words max-h-[300px] overflow-y-auto">
              {selectedReview.review}
            </p>

            <p className="text-yellow-500 font-medium mb-4">
              ⭐ {selectedReview.rating}/5
            </p>

            <button
              className="bg-blue-500 text-white px-4 py-2 rounded"
              onClick={() => setShowModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      )}
      {/* Modal */}
      {showModal && selectedReview && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-xl shadow-lg max-w-md w-full">
            <h3 className="font-bold text-xl mb-4 text-gray-900">Review</h3>
            <div className="mb-4">
              <p className="text-sm font-semibold text-gray-700 mb-1">
                Review Comments
              </p>
              <p className="text-gray-800 break-words whitespace-pre-line bg-gray-50 p-3 rounded-md border max-h-[200px] overflow-y-auto">
                {selectedReview.review}
              </p>
            </div>
            <div className="mb-6">
              <p className="text-sm font-semibold text-gray-700 mb-1">Rating</p>
              <div className="flex items-center text-yellow-500 font-medium">
                {Array.from({ length: 5 }).map((_, i) => (
                  <span key={i}>{i < selectedReview.rating ? "⭐" : "☆"}</span>
                ))}
              </div>
            </div>
            <div className="flex justify-end">
              <button
                className="px-4 py-2 rounded-lg border border-red-800 text-white bg-red-700 hover:bg-red-800 hover:text-white transition"
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {showTransferModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-xl shadow-lg p-6 w-[700px] max-h-[80vh] overflow-y-auto">
            <button
              onClick={() => {
                setTransferOrderId(null);
                setSelectedBranch(null);
                setShowTransferModal(false);
              }}
              className="absolute top-3 right-3 text-gray-1000 hover:text-gray-800"
            >
              ✕
            </button>
            <h2 className="text-xl font-bold mb-4">Transfer Order</h2>

            {/* From Branch */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                From Branch
              </label>
              <input
                type="text"
                value={transferOrderId.branch.area}
                disabled
                className="w-full border rounded p-2 bg-gray-100 cursor-not-allowed"
              />
            </div>

            {/* To Branch */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                To Branch
              </label>
              <select
                className="w-full border rounded p-2"
                value={selectedBranch}
                onChange={(e) => setSelectedBranch(e.target.value)}
              >
                <option value="">Select Branch</option>
                {branches
                  .filter(
                    (b) => b.branch_id !== transferOrderId.branch.branch_id,
                  )
                  .map((b) => (
                    <option key={b.branch_id} value={b.branch_id}>
                      {b.area}
                    </option>
                  ))}
              </select>
            </div>

            <div className="flex justify-end gap-2">
              <button
                onClick={() => {
                  setTransferOrderId(null);
                  setSelectedBranch(null);
                  setShowTransferModal(false);
                }}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={handleTransfer}
                disabled={!selectedBranch}
                className="px-4 py-2 bg-green-600 text-white rounded disabled:bg-gray-400 hover:bg-green-700"
              >
                Submit
              </button>
            </div>

            {/* <div className="mb-4">
              <h3 className="text-sm font-semibold mb-2">Transfer History</h3>
              {transferOrderId.OrderTransferHistory &&
              transferOrderId.OrderTransferHistory.length > 0 ? (
                <div className="overflow-x-auto max-h-60 overflow-y-auto border rounded">
                  <table className="w-full text-sm border-collapse">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="border px-3 py-2 text-left">From Branch</th>
                        <th className="border px-3 py-2 text-left">To Branch</th>
                        <th className="border px-3 py-2 text-left">Transferred By</th>
                        <th className="border px-3 py-2 text-left">Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transferOrderId.OrderTransferHistory.map((history, idx) => (
                        <tr key={idx} className="hover:bg-gray-50">
                          <td className="border px-3 py-2">
                            {history.from_branch?.area || "N/A"}
                          </td>
                          <td className="border px-3 py-2">
                            {history.to_branch?.area}
                          </td>
                          <td className="border px-3 py-2">{history.transferredByAdmin.name}</td>
                          <td className="border px-3 py-2 text-xs text-gray-600">
                            {new Date(history.createdAt).toLocaleString()}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="text-gray-500 text-sm">No transfer history available</p>
              )}
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderList;
